import React, { useEffect } from 'react';
import { Params, useParams } from 'react-router-dom';
import PTZPlayer from './PTZPlayer';

const { REACT_APP_SERVER_DECODER, REACT_APP_LOCAL_SERVER } = process.env;

const MainCCTV: React.FC = () => {
    const { encryptedId } = useParams<Params>();

    // Convierte encryptedId a un número y maneja casos donde sea undefined
    const assetId = encryptedId ? parseInt(encryptedId, 10) : 0;

    const hlsUrl = `${REACT_APP_SERVER_DECODER}/hls_output_${encryptedId}.m3u8`;

    useEffect(() => {
        // Función para detener el proceso en el backend
        const stopProcess = async () => {
            try {
                await fetch(`${REACT_APP_LOCAL_SERVER}/api/ffmpeg/stop`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: encryptedId }),
                });
                console.log(`Proceso ${encryptedId} detenido.`);
            } catch (error) {
                console.error('Error al detener el proceso:', error);
            }
        };

        // Cleanup al desmontar el componente
        return () => {
            // stopProcess();
        };
    }, [encryptedId]);

    return (
        <div style={{ width: "100%", height: "100vh", backgroundColor: "#000" }}>
            <PTZPlayer
                asset_id={assetId}
                src={hlsUrl} // URL del stream HLS
                backendUrl={`${REACT_APP_LOCAL_SERVER}`} // URL de tu backend para controlar la cámara PTZ
                width="80%" // Ajusta el tamaño según sea necesario
                height="auto"
            />
        </div>
    );
};

export default MainCCTV;
